module.exports = __webpack_public_path__ + "img/eye-in-wireless-compatible-wifi-6.813ddff6.png";